import React from 'react'
import './success.scss'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import CloseIcon from '@mui/icons-material/Close'

const Success = ({ error, onClose, backgroundColor, textColor, iconColor }) => {
  return (
    <div
      className='success'
      style={{
        backgroundColor: backgroundColor || '#C6F6C6',
        margin: '12px 0',
        borderRadius: '8px',
      }}
    >
      <div className='success-content'>
        <div className='success-container'>
          <CheckCircleOutlineIcon style={{ color: iconColor || '#066306' }} />
          <p style={{ color: textColor || '#066306' }}>{error}</p>
        </div>
        {onClose && (
          <CloseIcon
            onClick={onClose}
            className='success-close'
            style={{ color: iconColor || '#066306' }}
          />
        )}
      </div>
    </div>
  )
}

export default Success
